import { Copy } from 'lucide-react';
import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '../lib/utils';

export type CopyIconProps = ComponentPropsWithoutRef<typeof Copy>;

export function CopyIcon({ className, ...props }: CopyIconProps) {
  return <Copy className={cn('size-icon-sm', className)} {...props} />;
}
